import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import PublicNav from "@/components/PublicNav";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) { toast.error("Passwords do not match"); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password: pw });
      toast.success("Password reset. Sign in with your new password.");
      nav("/login");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not reset password");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen">
      <PublicNav />
      <div className="max-w-md mx-auto p-8" data-testid="reset-page">
        <div className="fx-panel p-8">
          <h1 className="font-display text-2xl font-bold text-white">Choose a new password</h1>
          <p className="text-sm text-slate-400 mt-1">Minimum 10 characters, at least one letter and one digit.</p>
          {!token ? (
            <div className="mt-6 text-sm text-amber-300">This link is missing its token. <Link to="/forgot-password" className="text-cyan-300">Request a new link</Link>.</div>
          ) : (
            <form onSubmit={submit} className="mt-6 space-y-4" data-testid="reset-form">
              <label className="block">
                <div className="text-xs text-slate-400 mb-1">New password</div>
                <input required type="password" minLength={10} value={pw} onChange={(e) => setPw(e.target.value)} className="w-full bg-[#0D1224] border border-[#1E293B] rounded-lg px-3 py-2 text-sm text-slate-100" data-testid="reset-pw" />
              </label>
              <label className="block">
                <div className="text-xs text-slate-400 mb-1">Confirm new password</div>
                <input required type="password" minLength={10} value={pw2} onChange={(e) => setPw2(e.target.value)} className="w-full bg-[#0D1224] border border-[#1E293B] rounded-lg px-3 py-2 text-sm text-slate-100" data-testid="reset-pw2" />
              </label>
              <button disabled={busy} className="fx-btn-primary w-full text-white font-medium py-2.5 rounded-lg disabled:opacity-60" data-testid="reset-submit">{busy ? "Saving…" : "Save new password"}</button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
